import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BASIC } from 'styles/spacingPresets';
import Box from 'components/Box';
import Card from 'components/Card';
import Icon from 'components/Icon';
import PageTitle from 'components/PageTitle';
import InlineList from 'components/InlineList';
import Pill from 'components/Pill';
import TextLink from 'components/TextLink';
import TooltipButton from 'components/TooltipButton';
import { NavMenu, NavMenuButton, NavMenuList } from 'components/NavMenu';
import Flex from 'components/Flex';
import ScrollableNav from 'components/ScrollableNav';
import { CloseButton } from 'components/EditorPageHeader';
import useBreakpoints from 'hooks/useBreakpoints';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MultipleSelectionHeader(_ref) {
  var title = _ref.title,
    providedTitleId = _ref.titleId,
    selection = _ref.selection,
    menuItems = _ref.menuItems,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    children = _ref.children,
    navigationLabel = _ref.navigationLabel,
    cardVariant = _ref.cardVariant,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var _useBreakpoints = useBreakpoints('m'),
    isDesktop = _useBreakpoints.m;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    shouldTrimList = _useState2[0],
    setShouldTrimList = _useState2[1];
  var titleId = providedTitleId || uniqueId;
  var selectionToShow = shouldTrimList ? selection.slice(0, 3) : selection;
  return /*#__PURE__*/_jsxs(Card, {
    as: "header",
    variant: cardVariant,
    position: "relative",
    pl: BASIC.LARGE,
    pr: "m",
    pt: BASIC.SMALL,
    breakpoints: BASIC.BREAKPOINTS,
    pb: children ? undefined : 's',
    overflow: "visible",
    "aria-labelledby": titleId,
    children: [/*#__PURE__*/_jsxs(Flex, {
      align: "top",
      children: [/*#__PURE__*/_jsx(Box, {
        grow: true,
        shrink: true,
        children: /*#__PURE__*/_jsx(PageTitle, {
          size: "large",
          id: titleId,
          children: title
        })
      }), (menuItems || onClose) && /*#__PURE__*/_jsxs(Box, {
        mt: "-xxs",
        mr: onClose ? '-xs' : '-s',
        children: [menuItems && /*#__PURE__*/_jsxs(NavMenu, {
          id: "-multi-more-options-menu",
          menuPlacement: "bottom-end",
          children: [/*#__PURE__*/_jsx(NavMenuButton, {
            variant: "transparent",
            iconRight: "tools",
            iconOnly: !isDesktop,
            children: t('actions_more_options')
          }), /*#__PURE__*/_jsx(NavMenuList, {
            children: menuItems
          })]
        }), onClose && /*#__PURE__*/_jsx(CloseButton, {
          onClick: onClose
        })]
      })]
    }), /*#__PURE__*/_jsx(Box, {
      fontSize: "s",
      mb: children && !actions.length ? undefined : 's',
      mt: "xs",
      children: /*#__PURE__*/_jsxs(InlineList, {
        spacing: "xs",
        "aria-labelledby": titleId,
        children: [selectionToShow.map(function (item) {
          return /*#__PURE__*/_jsx(Pill, {
            children: item.name
          }, item.id);
        }), selection.length > 3 && /*#__PURE__*/_jsxs(TextLink, {
          bold: true,
          as: "button",
          onClick: function onClick() {
            return setShouldTrimList(function (prev) {
              return !prev;
            });
          },
          children: [/*#__PURE__*/_jsx(Icon, {
            scale: 0.93,
            name: shouldTrimList ? 'plus' : 'minus',
            mt: -2,
            mr: "xxxs"
          }), shouldTrimList ? t('actions_more_count', {
            count: selection.length - 3
          }) : t('actions_show_less')]
        })]
      })
    }), actions.length > 0 && /*#__PURE__*/_jsx(Box, {
      mt: "m",
      children: /*#__PURE__*/_jsx(InlineList, {
        spacing: "xs",
        children: actions.map(function (action) {
          return /*#__PURE__*/_jsx(TooltipButton, {
            title: action.hint,
            size: "medium",
            onClick: action.onClick,
            isDisabled: action.isDisabled,
            icon: action.icon,
            children: action.title
          }, action.title);
        })
      })
    }), children && /*#__PURE__*/_jsx(ScrollableNav, {
      navigationLabel: navigationLabel,
      children: children
    })]
  });
}
export default MultipleSelectionHeader;